import React, { Fragment, useState } from "react";
import { DateTime } from "luxon";

import { CalendarDay } from "./CalendarDay";
import { CalendarMonth } from "./CalendarMonth";
import { CalendarWeek } from "./CalendarWeek";
import { HeaderCalendarUsers } from "../molecules/HeaderCalendarUsers";
import { BaseEvent } from "@/app/events/events";

type CalendarUserProps = {
  functionOpenModalActividades?: () => void;
  events: Array<BaseEvent>;
  loading: boolean;
  onMonthChange?: (month: DateTime) => void;
  initialDateTime: DateTime;
  onEventClick?: (event: BaseEvent) => void;
};

export const CalendarUser: React.FC<CalendarUserProps> = ({
  functionOpenModalActividades,
  events,
  loading,
  onMonthChange,
  initialDateTime,
  onEventClick,
}) => {
  const [selectCalendar, setSelectCalendar] = useState<
    "week" | "day" | "month"
  >("month");
  const [currentDateTime, setCurrentDateTime] = useState(initialDateTime);

  const handleNext = () => {
    if (selectCalendar == "day") {
      setCurrentDateTime(currentDateTime.plus({ days: 1 }).startOf("day"));
    }

    if (selectCalendar == "month") {
      setCurrentDateTime(currentDateTime.plus({ months: 1 }).startOf("month"));
      if (onMonthChange) {
        onMonthChange(currentDateTime.plus({ months: 1 }).startOf("month"));
      }
    }

    if (selectCalendar == "week") {
      setCurrentDateTime(currentDateTime.plus({ weeks: 1 }).startOf("week"));
    }
  };

  const handlePrev = () => {
    if (selectCalendar == "day") {
      setCurrentDateTime(currentDateTime.minus({ days: 1 }).startOf("day"));
    }

    if (selectCalendar == "month") {
      setCurrentDateTime(currentDateTime.minus({ months: 1 }).startOf("month"));
      if (onMonthChange) {
        onMonthChange(currentDateTime.minus({ months: 1 }).startOf("month"));
      }
    }

    if (selectCalendar == "week") {
      setCurrentDateTime(currentDateTime.minus({ weeks: 1 }).startOf("week"));
    }
  };

  const handleNextMonth = () => {
    setCurrentDateTime(currentDateTime.plus({ months: 1 }).startOf("month"));
  };

  const handlePrevMonth = () => {
    setCurrentDateTime(currentDateTime.minus({ months: 1 }).startOf("month"));
  };

  const handleToday = () => {
    if (selectCalendar == "day") {
      setCurrentDateTime(DateTime.now().startOf("day"));
    }

    if (selectCalendar == "month") {
      setCurrentDateTime(DateTime.now().startOf("month"));
    }

    if (selectCalendar == "week") {
      setCurrentDateTime(DateTime.now().startOf("week"));
    }
  };

  const handleViewTypeChange = (viewType: "week" | "day" | "month") => {
    setSelectCalendar(viewType);
  };

  return (
    <Fragment>
      {loading ? (
        <div className="flex flex-1 flex-col items-center justify-center">
          <div
            className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-primary"
            role="status"
          >
            <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
              Loading...
            </span>
          </div>
        </div>
      ) : (
        <Fragment>
          <div className="flex h-full flex-col">
            <HeaderCalendarUsers
              currentDateTime={currentDateTime}
              selectCalendar={selectCalendar}
              onToday={handleToday}
              onNext={handleNext}
              onPrev={handlePrev}
              hideFilter={false}
              onViewTypeChange={handleViewTypeChange}
            />
          </div>
          {selectCalendar === "day" && (
            <CalendarDay
              currentDateTime={currentDateTime}
              onEventClick={onEventClick}
              onNextMonth={handleNextMonth}
              onPrevMonth={handlePrevMonth}
              events={events}
              setCurrentDateTime={setCurrentDateTime}
            />
          )}
          {selectCalendar === "week" && (
            <CalendarWeek
              currentDateTime={currentDateTime}
              onEventClick={onEventClick}
              events={events}
            />
          )}
          {selectCalendar === "month" && (
            <CalendarMonth
              currentDateTime={currentDateTime}
              events={events}
              onEventClick={onEventClick}
              //functionOpenModalActividades={() => functionOpenModalActividades}
            />
          )}
        </Fragment>
      )}
    </Fragment>
  );
};
